import { render, staticRenderFns } from "./FlashNewsEditView.vue?vue&type=template&id=942c7404&"
import script from "./FlashNewsEditView.vue?vue&type=script&lang=ts&"
export * from "./FlashNewsEditView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports